// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3FhWW","title":"FrontImage_title__2GJ_d"};